import 'jquery.cookie';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
var news = {};

(function (newsApp) {
	var filterModel = {
		SearchTerm: "",
		Area: "",
		Tag: "",
		Page: 1
	};
	const cookieName = "_oa_blogSearchParams";
	var pageType = $("#news-search-form").data("type");

	var fromPopState = false;
	var blockPopstateEvent = true;
	var browserSupportsHistoryApi = window.history && 'pushState' in window.history;

	if (browserSupportsHistoryApi) {
		// prevent Chrome from calling onpopstate on initial load
		$(window).on('load', function () {
			// The timeout ensures that popstate-events will be unblocked right
			// after the load event occured, but not in the same event-loop cycle.
			setTimeout(function () { blockPopstateEvent = false; }, 0);
		});

		$(window).on('popstate', function () {
			if (blockPopstateEvent && document.readyState === "complete") {
				return;
			}
			fromPopState = true;
			performSearchFromUrl();
		});
	}

	function pushHistory() {
		if (browserSupportsHistoryApi && !fromPopState) {
			var currentPath = window.location.pathname;
			var query = "?";
			var queryArray = [];
			if (filterModel.SearchTerm) {
				queryArray.push("search=" + filterModel.SearchTerm);
			}
			if (filterModel.Area) {
				queryArray.push("area=" + filterModel.Area);
			}
			if (filterModel.Tag) {
				queryArray.push("tag=" + filterModel.Tag);
			}
			if (filterModel.Page) {
				queryArray.push("page=" + filterModel.Page);
			}
			query += queryArray.join("&");
			history.pushState(null, null, currentPath + query);
		}
		fromPopState = false;
	}

	function performSearchFromUrl() {
		filterModel.SearchTerm = "";
		filterModel.Area = "";
		filterModel.Tag = "";
		filterModel.Tag = 1;
		newsApp.setInputValue();

		if (window.location.search.length > 1) {
			for (var aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&");
				nKeyId < aCouples.length;
				nKeyId++) {
				aItKey = aCouples[nKeyId].split("=");
				if (aItKey.length <= 1)
					continue;
				var key = decodeURIComponent(aItKey[0]).toLowerCase();
				var val = decodeURIComponent(aItKey[1]);

				if (key === "search") {
					filterModel.SearchTerm = val;
					newsApp.setInputValue();
				} else if (key === "area") {
					filterModel.Area = val;
				} else if (key === "tag") {
					filterModel.Tag = val;
				} else if (key === "page") {
					filterModel.Page = val;
				}
			}
		}
		newsApp.GetSearchResults();
	}

	newsApp.setInputValue = function () {
		$("#search").val(filterModel.SearchTerm);
		$("#searchMobile").val(filterModel.SearchTerm);
		$("#area-select").val(filterModel.Area);
	};

	newsApp.GetSearchResults = function () {
		$.ajax({
			url: "/umbraco/surface/NewsSurface/GetSearchResults",
			type: "POST",
			data: filterModel,
			dataType: "html",
			success: function (data) {
				$(".js-news-results").html(data);
				pushHistory();

				$([document.documentElement, document.body]).animate({
					scrollTop: $(".js-news-results").offset().top - $("header").outerHeight()
				}, 200);
			}
		});
	};

	$(document).ready(function () {
		//prevent fancybox triggering performSearchFromUrl() after window close
		$.fancybox.defaults.hash = false;

		//check if querystring params exist on load/reload
		const urlParams = new URLSearchParams(window.location.search);
		var hasUrlParams = urlParams.has('search') || urlParams.has('area') || urlParams.has('tag') || urlParams.has('page');

		if (hasUrlParams) {
			if (urlParams.get('search')) {
				filterModel.SearchTerm = urlParams.get('search');
				newsApp.setInputValue();
			}

			if (urlParams.get('area')) {
				filterModel.Area = urlParams.get('area');
				newsApp.setInputValue();
			}

			if (urlParams.get('tag')) {
				filterModel.Tag = urlParams.get('tag');
			}

			if (urlParams.get('page')) {
				filterModel.Page = urlParams.get('page');
			}

			setCookie();

		} else {
			if (pageType === "blogLanding") {
				removeCookie();
			}

			// get params saved in cookie 
			var cookieValue = null;
			if (typeof $.cookie(cookieName) !== 'undefined') {
				cookieValue = JSON.parse($.cookie(cookieName));
			}

			if (cookieValue) {
				if (cookieValue.SearchTerm) {
					filterModel.SearchTerm = cookieValue.SearchTerm;
					newsApp.setInputValue();
				}
				if (cookieValue.Area) {
					filterModel.Area = cookieValue.Area;
					newsApp.setInputValue();
				}
				if (cookieValue.Tag) {
					filterModel.Tag = cookieValue.Tag;
				}
				if (cookieValue.Page) {
					filterModel.Page = cookieValue.Page;
				}
			}
			removeCookie();
		}

		
		$("#news-search-form").submit(function (e) {
			checkPageType(e);
			setCookie();
		});

		// save filterModel values in cookie to populate the selected options of the filter on Blog Article page
		function setCookie() {
			var date = new Date();
			var minutes = 1;
			date.setTime(date.getTime() + (minutes * 60 * 1000));
			$.cookie(cookieName, JSON.stringify(filterModel), { expires: date, path: '/' });
		}

		function removeCookie() {
			$.cookie(cookieName, null, { path: '/' });
		}

		function checkPageType(e) {
			// check if on article or article landing page (blogLanding)
			if (pageType === "blogLanding") {
				e.preventDefault();
				getFilterValues();
			}
			//else do nothing and allow form to submit to blog landing page
		}

		function getFilterValues() {
			filterModel.SearchTerm = $("#search").val();
			filterModel.Area = $("#area-select").val();
			filterModel.Page = 1;
			hideCustomTagBlock();
			newsApp.GetSearchResults();
		}

		function hideCustomTagBlock() {
			if (document.querySelector(".js-ctb")) {
				$(".js-ctb").hide();
			}
		}


		//on pagination click event
		$(document).on('click', 'ul.pagination a', function (e) {
			e.preventDefault();
			filterModel.Page = $(this).data('page');
			setCookie();
			newsApp.GetSearchResults();
		});


		// copy searchMobile text to search field
		$("#searchMobile").on("keyup paste", function () {
			$("#search").val($(this).val());
		});
	});

})(news);
